import React from "react"
import tw from "twin.macro"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Hero from "../components/hero"
import FeatureCard from "../components/feature-card"
import LDMSFeature from "../components/ldms-feature"

import PrinterIcon from "../images/icon-printer.svg"
import BarcodeIcon from "../images/icon-barcode.svg"
import TemplatesIcon from "../images/icon-templates.svg"

const FeatureCardDeck = tw.div`mt-8 grid grid-cols-1 md:grid-cols-3 gap-8`

const features = [
  {
    title: "No Special Hardware",
    icon: PrinterIcon,
    content:
      "Labelscape was designed to work with common desktop printers and labels. No need for expensive specialty specimen label printing equipment.",
  },
  {
    title: "Flexible Barcode Support",
    icon: BarcodeIcon,
    content:
      "Labels can encode data in several built-in formats. If you need to integrate with another application, you can even build your own custom barcodes.",
  },
  {
    title: "Create Templates",
    icon: TemplatesIcon,
    content:
      "Always creating labels for the same visits? Create a template with all the expected collections and re-use it.",
  },
]

const IndexPage = () => (
  <Layout Hero={Hero}>
    <SEO title="Home" />
    <FeatureCardDeck>
      {features.map(feature => (
        <FeatureCard key={feature.title} {...feature} />
      ))}
    </FeatureCardDeck>
    <LDMSFeature />
  </Layout>
)

export default IndexPage
